import { setNewRelicCustomAttribute } from 'ddc-new-relic';

export default (results) => {
	return results.filter(({ path, title }) => {
		if (!path) {
			setNewRelicCustomAttribute(
				'wsSiteTextSearch-noPageAvailable',
				`No Page Found for "${title}" Result`
			);
			return false;
		}
		return true;
	});
};
